module.exports = __webpack_public_path__ + "img/delight.a35fcb83.svg";